<template>
  <div class="dialogContainer">
    <div
      class="modalDialog"
      data-automation="file-hash-dialog"
      :style="modalStyle"
    >
      <div
        class="modalClose"
        @click="closeDialog"
      />
      <slot>dialog content goes here</slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ModalDialog',
  props: {
    modalStyle: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    closeDialog: function (event) {
      this.$emit('closeDialog', null)
    },
  },
}

</script>
